import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { MasterDataType } from "domain/entity/MasterData/MasterDataEntity";
import { CopyTariffProposalItemCriteria } from "domain/entity/StandardProposal/CopyTariffProposalItemCriteria";
import { SaveTariffProposalItemCriteria } from "domain/entity/StandardProposal/SaveTariffProposalItemCriteria";
import { EMPTY_STANDARD_PROPOSAL_ENTITY, StandardProposalEntity } from "domain/entity/StandardProposal/StandardProposalEntity";
import { EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY, StandardProposalItemEntity } from "domain/entity/StandardProposal/StandardProposalItemEntity";
import { EMPTY_STANDARD_PROPOSAL_ITEM_PREVIEW_ENTITY, StandardProposalItemPreviewEntity } from "domain/entity/StandardProposal/StandardProposalItemPreviewEntity";
import { EMPTY_STANDARD_PROPOSAL_SEARCH_CRITERIA, StandardProposalSearchCriteria } from "domain/entity/StandardProposal/StandardProposalSearchCriteria";
import { EMPTY_STD_PROPOSAL_COPY_TO_ENTITY, StdProposalCopyToEntity } from "domain/entity/StandardProposal/StdProposalCopyToEntity";
import { EMPTY_STD_PROPOSAL_COPY_TO_NEW_PROPOSAL_ENTITY, StdProposalCopyToNewProposalEntity } from "domain/entity/StandardProposal/StdProposalCopyToNewProposalEntity";
import { EMPTY_STD_PROPOSAL_COPY_TO_PROPOSAL_ENTITY, StdProposalCopyToProposalEntity } from "domain/entity/StandardProposal/StdProposalCopyToProposalEntity";
import { EMPTY_STD_PROPOSAL_IS_ENTITY, StdProposalIsEntity } from "domain/entity/StandardProposal/StdProposalIsEntity";
import { EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY, StdProposalTariffItemTierEntity } from "domain/entity/StandardProposal/StdProposalTariffItemTierEntity";
import { TariffCodeComboxSearchCriteria } from "domain/entity/StandardProposal/TariffCodeComboxSearchCriteria";
import { ShiftRepository } from "domain/repository/Common/ShiftRepo";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { ExchangeRateRepository } from "domain/repository/ExchangeRate/ExchangeRateRepo";
import { MasterDataRepository } from "domain/repository/MasterData/MasterDataRepo";
import { StandardProposalItemRepository } from "domain/repository/StandardProposal/StandardProposalItemRepo";
import { StandardProposalRepository } from "domain/repository/StandardProposal/StandardProposalRepo";
import { StandardTariffCodeRepository } from "domain/repository/TariffCode/StandardTariffCodeRepo";
import { TariffTypeRepository } from "domain/repository/TariffCode/TariffTypeRepo";
import _ from "lodash";
import { copyEditNewProposalNoValidationSchema, copyEditProposalNoValidationSchema, copyToEditPercentageValidationSchema, createStandardProposalValidationSchema, createTariffItemValidationSchema, createTempSaveTariffItemTierValidationSchema } from "presentation/constant/StandardProposal/StandardProposalValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { DropdownProps } from "presentation/model/DropdownProps";
import { StandardProposalModel } from "presentation/model/StandardProposal/StandardProposalModel";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface StandardProposalVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<StandardProposalModel>> | ((value: SetStateAction<StandardProposalModel>) => void),
    ],
    companyRepo: CompanyRepository,
    masterDataRepo: MasterDataRepository,
    standardProposalRepo: StandardProposalRepository,
    standardProposalItemRepo: StandardProposalItemRepository,
    exchangeRateRepo: ExchangeRateRepository,
    standardTariffCodeRepo: StandardTariffCodeRepository,
    tariffTypeRepo: TariffTypeRepository,
    shiftRepo: ShiftRepository,
}

export const StandardProposalVM = ({ dispatch, companyRepo, masterDataRepo, standardProposalRepo, standardProposalItemRepo, standardTariffCodeRepo
    , exchangeRateRepo, tariffTypeRepo, shiftRepo
}: StandardProposalVMProps) => {
    const [standardProposalDispatch] = dispatch;

    const onShowLoading = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isLoading: true,
            }
        })
    }

    const onHideLoading = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isLoading: false,
            }
        })
    }

    const updateSelectedRows = async (rows: any[]) => {
        if (rows?.length === 1) {
            searchStandardProposalItem(rows[0]);
        }
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: rows,
                currentSelectedRow: rows.length === 1 ? rows[0] : { ...EMPTY_STANDARD_PROPOSAL_ENTITY },
                isShowTariffItemPanel: (rows.length === 1 ? true : false),
                forceRefresh: !prevState.forceRefresh,
                isShowCriteriaPanel: false,
                isUpdateOrAdd: false,
                isAddTariffItem: false,
                isEditStdProposal: false,
                isShowTariffItemTierPanel: false,
                standardProposalItemList: [],
                rejectReason: rows.length === 1 ? rows[0].rejectReason : "",
                currentSelectedRowKey: rows.length === 1 ? rows[0].key : "",
                stdProposalState: {
                    ...prevState.stdProposalState,
                    isRead: true,
                }
            }
        })
    }

    const updateCurrentSelectedRow = async (row: any) => {
        if (row) {
            if (!row.key) {
                return;
            }

            // initComboBoxTariffCode(entity,"all");
            await standardProposalItemRepo.searchStandardProposalItem(row).then((data) => {
                //const newData = _.orderBy(data, ["priority"]);
                standardProposalDispatch(prevState => {
                    let tempProposalItemList = prevState.standardProposalItemList;

                    if (row.proposalItemKey && data && data.length > 0) {
                        const proposalItem = data[0];
                        const prevList = tempProposalItemList || [];

                        const existingIndex = prevList.findIndex(item => item.key === proposalItem.key);

                        if (existingIndex !== -1) {
                            tempProposalItemList = prevList.map((item, index) =>
                                index === existingIndex ? { ...proposalItem } : { ...item }
                            );
                        } else {
                            tempProposalItemList = [...prevList, { ...proposalItem }];
                        }
                    } else {
                        tempProposalItemList = [...data];
                    }

                    const newData = _.orderBy(tempProposalItemList, ["priority"]);
                    return {
                        ...prevState,
                        selectedRows: [row],
                        currentSelectedRow: row,
                        forceRefresh: !prevState.forceRefresh,
                        standardProposalItemList: newData,
                        isShowCriteriaPanel: false,
                        isUpdateOrAdd: false,
                        isAddTariffItem: false,
                        isEditStdProposal: false,
                        isShowTariffItemTierPanel: false,
                        stdProposalState: {
                            ...prevState.stdProposalState,
                            isRead: true,
                        },
                        initialProposalItem: true,
                    }
                })
            }).catch((error) => {
                return [];
            })
        }
    }

    const updateCopyToSelectedRows = async (rows: any[]) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                selectCopyToStdProposalRows: rows,
            }
        })
    }

    const updateSelectedPercentageRow = async (rows: any[]) => {
        if (rows.length === 1) {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    copyToPercentage: rows[0],
                }
            })

        } else {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    isEditPercentage: false,
                }
            })
        }
    }

    const updateSelectedNewProposalNoRow = async (rows: any[]) => {
        if (rows.length === 1) {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    copyToEditNewProposal: rows[0],
                }
            })
        } else {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    isEditNewProposalNo: false,
                }
            })
        }
    }

    const updateSelectedProposalNoRow = async (rows: any[]) => {
        if (rows.length === 1) {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    copyToProposalNo: rows[0],
                }
            })
        } else {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    isEditProposalNo: false,
                }
            })
        }
    }

    const updateSelectedTariffItemRows = async (rows: any[]) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                tariffItemSelectedRows: rows,
            }
        })
    }
    const onTariffItemRowDoubleClick = async (row: StandardProposalItemEntity) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                currentTariffItem: row,
                isShowTariffItemTierPanel: true,
                isShowCopyPanel: false,
                copyToCompanyList: [],
                copyToNewProposalList: [],
                copyToProposalList: [],
                isEditPercentage: false,
                isEditProposalNo: false,
                isEditNewProposalNo: false,
                selectCopyToStdProposalRows: [],
                isAddTariffItem: false,
            }
        })
    }

    const updateSelectedTariffItemTierRows = async (rows: any[]) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                tariffItemTierSelectedRows: rows,
                currentTariffItemTier: rows.length === 1 ? rows[0] : { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY },
            }
        })
    }

    const updateSelectedTariffItemIsRows = async (rows: any[]) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                tariffItemIsSelectedRows: rows,
                currentTariffItemIs: rows.length === 1 ? rows[0] : { ...EMPTY_STD_PROPOSAL_IS_ENTITY },
            }
        })
    }

    const onRowClick = (entity: StandardProposalEntity) => {
        standardProposalDispatch(prevState => {
            let isShowDtl = false;
            if ('' !== prevState.currentSelectedRowKey && entity.key === prevState.currentSelectedRowKey) {
                isShowDtl = true;
            }
            return {
                ...prevState,
                isShowTariffItemPanel: isShowDtl ? prevState.isShowTariffItemPanel : isShowDtl,
            }
        })
    }

    const onRowDoubleClick = (entity: StandardProposalEntity) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isShowCriteriaPanel: false,
                isShowTariffItemPanel: true,
                isUpdateOrAdd: false,
                isAddTariffItem: false,
                isShowTariffItemTierPanel: false,
                standardProposalItemList: [],
                currentSelectedRow: entity,
                rejectReason: entity.rejectReason ?? "",
                currentSelectedRowKey: entity.key,
                stdProposalState: {
                    ...prevState.stdProposalState,
                    isRead: true,
                }
            }
        })
    }

    const onTariffItemCloseClick = (isEditStdProposal: boolean) => {
        if (isEditStdProposal) {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    isShowTariffItemPanel: true,
                    isEditStdProposal: false,
                    isMasterOrAlliance: false,
                    currentSelectedRow: { ...prevState.standardProposalAllList?.find(row => row.key === prevState.currentSelectedRow.key) ?? prevState.currentSelectedRow },
                }
            })
        } else {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    isShowTariffItemPanel: false,
                    isShowTariffItemTierPanel: false,
                    isEditStdProposal: false,
                    isUpdateOrAdd: false,
                    isEditTier: false,
                    isEditIs: false,
                    isAddIs: false,
                    isAddTier: false,
                    standardProposalItemList: null,
                    currentSelectedRowKey: '',
                    currentTariffItem: { ...EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY },
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        isRead: true,
                    },
                    isMasterOrAlliance: false,
                    deleteItemList: []
                }
            })
        }
    }

    const onTariffItemEidtClick = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isEditStdProposal: true,
                isUpdateOrAdd: false,
                isShowTariffItemTierPanel: false,
                isEditTier: false,
                isEditIs: false,
                isAddIs: false,
                isAddTier: false,
                currentSelectedEditRow: prevState.currentSelectedRow,
                deleteItemList: []
                // stdProposalState:{
                //     ...prevState.stdProposalState,
                //     isRead: false,
                // }
            }
        })
    }

    const onTariffItemAddClick = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isEditStdProposal: false,
                isAddTariffItem: true,
                isUpdateOrAdd: true,
                isShowTariffItemTierPanel: true,
                currentTariffItem: {
                    ...EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY,
                    tempKey: _.uniqueId(),
                },
                // stdProposalState:{
                //     ...prevState.stdProposalState,
                //     isRead: false,
                // }
            }
        })
    }

    const onTariffItemTierCloseClick = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isShowTariffItemTierPanel: false,
                isEditStdProposal: false,
                isAddTariffItem: false,
                isUpdateOrAdd: false,
                isEditTier: false,
                isEditIs: false,
                isAddIs: false,
                isAddTier: false,
                currentTariffItem: { ...EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY },
                currentTariffItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY },
                stdProposalState: {
                    ...prevState.stdProposalState,
                    allFormState: {
                    },
                }
            }
        })
    }


    const onTariffItemTierEidtClick = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isEditTier: true,
                isEditIs: false,
                isAddIs: false,
                isAddTier: false,
                isUpdateOrAdd: true,
                currentEditTariffItemTier: prevState.currentTariffItemTier,
            }
        })
    }

    const onTariffItemISEidtClick = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isEditIs: true,
                isEditTier: false,
                isAddIs: false,
                isAddTier: false,
                isUpdateOrAdd: true,
                currentEditTariffItemIs: prevState.currentTariffItemIs,
            }
        })
    }

    const loadDropdownOption = async () => {
        const [companyList, operatingTmls, forwarderCodes, currencies, tariffNatures,
            tariffTypes, shiftCodes, tariffNatureMaps] = await Promise.all([
                companyRepo.getAllCompanyForCombobox(),
                masterDataRepo.getMasterDataByKey(MasterDataType.TERMINAL),
                masterDataRepo.getMasterDataByKey(MasterDataType.FORWARDER_CODE),
                exchangeRateRepo.getAllCurrencies(),
                masterDataRepo.getMasterDataByKey(MasterDataType.TAR_NATURE),
                tariffTypeRepo.getAllActiveTariffTypes(),
                shiftRepo.getShiftByType('INTENSIVE'),
                standardTariffCodeRepo.getTariffForTariffNature()
            ]);

        /*await companyRepo.getAllCompanyForCombobox().then(
            companies => {*/
        let companies = companyList?.filter(company => company.activeInd === 'Y');
        let companyCodeDropdownOption = companies?.map((company) => ({
            dropdownLabel: company.companyCode,
            tagLabel: company.id.toString(),
            value: company.companyCode,
        })) ?? []
        companyCodeDropdownOption = _.orderBy(companyCodeDropdownOption, "dropdownLabel");

        /*standardProposalDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                companyCodeDropdownOptions: [
                    ...companyCodeDropdownOption],

            }
        }))
    }
);*/

        /*await masterDataRepo.getMasterDataByKey(MasterDataType.TERMINAL).then(
            operatingTmls => {*/
        const operatingTmlDropdownOptions = operatingTmls?.map((operatingTml) => ({
            dropdownLabel: operatingTml.code,
            tagLabel: operatingTml.code,
            value: operatingTml.code,
        })) ?? []

        /*standardProposalDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                operatingTmlDropdownOptions: operatingTmlDropdownOptions,
            }
        }))
    }
)*/

        /*await masterDataRepo.getMasterDataByKey(MasterDataType.FORWARDER_CODE).then(
            forwarderCodes => {*/
        const forwarderCodesDropdownOptions = forwarderCodes?.map((forwarderCode) => ({
            dropdownLabel: forwarderCode.code,
            tagLabel: forwarderCode.code,
            value: forwarderCode.code,
        })) ?? []

        /*standardProposalDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                forwarderCodeDropdownOptions: forwarderCodesDropdownOptions,
            }
        }))
    }
)*/

        /*await exchangeRateRepo.getAllCurrencies().then(
            currencies => {*/
        let currencyDropdownOptions = currencies?.map((currency) => ({
            dropdownLabel: currency.currencyCode,
            tagLabel: currency.currencyCode,
            value: currency.currencyCode,
        })) ?? []

        /*standardProposalDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                currencyCodeDropdownOptions: currencyDropdownOptions,
            }
        }))
    }
)*/

        /*await masterDataRepo.getMasterDataByKey(MasterDataType.TAR_NATURE).then(
            tariffNatures => {*/
        let tariffNatureDropdownOptions = tariffNatures?.map((entity) => ({
            dropdownLabel: entity.code,
            tagLabel: entity.code,
            value: entity.code,
        })) ?? []

        /*standardProposalDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                tariffNatureDropdownOptions: tariffNatureDropdownOptions,
            }
        }))
    }
)*/

        /*await tariffTypeRepo.getAllActiveTariffTypes().then(
            tariffs => {*/
        let newTariffs = _.orderBy(tariffTypes, ["tariffType"]);
        let tariffTypeDropdownOptions = newTariffs?.map((entity) => ({
            dropdownLabel: entity.tariffType,
            tagLabel: entity.tariffType,
            value: entity.tariffType,
        })) ?? []

        /*standardProposalDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                tariffTypeDropdownOptions: tariffTypeDropdownOptions,
            }
        }))
    }
)*/

        /*await shiftRepo.getShiftByType('INTENSIVE').then(
            shiftCodes => {*/

        let newShifts = _.orderBy(shiftCodes, ["shiftCode"]);
        let shiftCodeDropdownOptions: DropdownProps[] = [];
        newShifts?.forEach(shift => {
            const isShiftCodeExisted = shiftCodeDropdownOptions?.find(t =>
                t.value === shift.shiftCode);
            if (!isShiftCodeExisted) {
                shiftCodeDropdownOptions.push({
                    dropdownLabel: shift.shiftCode,
                    tagLabel: shift.shiftCode,
                    value: shift.shiftCode,
                })
            }
        })

        /*standardProposalDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                shiftCodeDropdownOptions: shiftCodeDropdownOptions,
            }
        }))
    }
)*/

        /*await standardTariffCodeRepo.getTariffForTariffNature().then(
            tariffNatures => {
                standardProposalDispatch(prevState => ({
                    ...prevState,
                    tariffNatureMap: tariffNatures
                }))
            }
        )*/

        standardProposalDispatch(prevState => ({
            ...prevState,

            dynamicOptions: {
                ...prevState.dynamicOptions,
                companyCodeDropdownOptions: [...companyCodeDropdownOption],
                operatingTmlDropdownOptions: operatingTmlDropdownOptions,
                forwarderCodeDropdownOptions: forwarderCodesDropdownOptions,
                currencyCodeDropdownOptions: currencyDropdownOptions,
                tariffNatureDropdownOptions: tariffNatureDropdownOptions,
                tariffTypeDropdownOptions: tariffTypeDropdownOptions,
                shiftCodeDropdownOptions: shiftCodeDropdownOptions,
            },

            tariffNatureMap: tariffNatureMaps
        }))

    }

    const onSearchCriteriaResetClick = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: EMPTY_STANDARD_PROPOSAL_SEARCH_CRITERIA
            }
        })
    }

    const onSearchClick = async () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isShowCriteriaPanel: !prevState.isShowCriteriaPanel
            }
        });
    }


    const searchAllStandardProposal = async () => {
        /*let newSearchCriteria = { ...EMPTY_STANDARD_PROPOSAL_SEARCH_CRITERIA }
        await standardProposalRepo.searchStandardProposal(newSearchCriteria).then((data) => {*/
        await standardProposalRepo.standardProposalCount().then((data) => {
            if (data && ('pendingApprovalCount' in data || 'rejectedCount' in data)  /*data.length > 0*/) {
                /*let isRejectedCount = 0;
                let isPendingApprovalCount = 0;
                // let isAllCount = 0;
                // isAllCount = data.length;
                isRejectedCount = data.filter(entity => entity.status === "REJECTED").length;
                isPendingApprovalCount = data.filter(entity => (entity.status === "FINALIZED") && !entity.confirmedDate).length;
                const newData = data.map(entity => ({
                    ...entity,
                    tariffNatureList: entity.tariffNature ? entity.tariffNature.split(',') : []
                }));
                const copyToData = data.filter(entity => entity.status === "REJECTED" || entity.status === "NEW");*/
                standardProposalDispatch(prevState => {
                    return {
                        ...prevState,
                        /*standardProposalAllList: newData,
                        copyToStandardProposalList: copyToData,*/
                        // isAllCount: isAllCount,
                        isPendingApprovalCount: data.pendingApprovalCount || 0,
                        isRejectedCount: data.rejectedCount || 0,
                        selectedRows: [],
                        isAllowAutoSearch: false,
                    }
                })
            } else {
                standardProposalDispatch(prevState => {
                    return {
                        ...prevState,
                        standardProposalAllList: [],
                        isPendingApproval: false,
                        isRejected: false,
                        // isAll: false,
                        isPendingApprovalCount: 0,
                        isRejectedCount: 0,
                        // isAllCount: 0,
                    }
                })
            }
        }).catch((error) => {
            return [];
        })
    }

    const searchStandardProposal = async (searchCriteria: StandardProposalSearchCriteria) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: [],
                deleteTierList: [],
                deleteIsList: [],
                deleteItemList: [],
                // standardProposalList: [],
                isPendingApproval: false,
                isRejected: false,
                isShowTariffItemPanel: false,
                isShowTariffItemTierPanel: false,
                isUpdateOrAdd: false,
                isAddTariffItem: false,
                isShowCopyPanel: false,
                isEditPercentage: false,
                isEditProposalNo: false,
                isEditNewProposalNo: false,
                isCopyEditTier: false,
                selectCopyToStdProposalRows: [],
                standardProposalItemList: null,
                currentSelectedRow: { ...EMPTY_STANDARD_PROPOSAL_ENTITY },
                isAddIs: false,
                isEditIs: false,
                isAddTier: false,
                isEditTier: false,
                isEditStdProposal: false,
                copyToCompanyList: [],
                copyToPercentageList: [],
                copyToProposalList: [],
                copyToNewProposalList: [],
                copyToEditNewProposal: { ...EMPTY_STD_PROPOSAL_COPY_TO_NEW_PROPOSAL_ENTITY },
                copyToEditPercentage: { ...EMPTY_STD_PROPOSAL_COPY_TO_ENTITY },
                copyToProposalNo: { ...EMPTY_STD_PROPOSAL_COPY_TO_PROPOSAL_ENTITY },
                // isAll: false,
            }
        })

        await Promise.allSettled([
            searchAllStandardProposal(),
            standardProposalRepo.searchStandardProposal(searchCriteria).then((data) => {
                if (data) {
                    data = _.orderBy(data, ["companyCode", "proposalNo"], ['asc', 'asc']);
                    const newData = data.map(entity => ({
                        ...entity,
                        tariffNatureList: entity.tariffNature ? entity.tariffNature.split(',') : []
                    }));
                    standardProposalDispatch(prevState => {
                        return {
                            ...prevState,
                            standardProposalList: newData,
                            searchCriteria: searchCriteria,
                            selectedRows: [],
                            isAllowAutoSearch: false,
                            searchStatus: ''
                        }
                    })
                } else {
                    standardProposalDispatch(prevState => {
                        return {
                            ...prevState,
                            standardProposalList: [],
                            searchCriteria: searchCriteria,
                            selectedRows: [],
                            isAllowAutoSearch: false,
                            searchStatus: ''
                        }
                    })
                }
            }).catch((error) => {
                return [];
            })
        ])
    }

    const onSearchInputTextChange = (e: ChangeEvent<HTMLInputElement>, fieldName: string) => {
        standardProposalDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName]: e.target.value,
            }
        }))
    };

    const onMultipleDropdownChange = (e: any, fieldName: string) => {
        /*standardProposalDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName]: _.uniq(e?.map((item: DropdownProps) => item.value)),
            }
        }));*/
        standardProposalDispatch(prevState => {
            const tempVal = _.uniq(e?.map((item: DropdownProps) => item.value) || []);

            let tempCompIds: string[] = [];
            if (fieldName === "companyCodeList") {
                const tempCompDropOpts = prevState.dynamicOptions.companyCodeDropdownOptions || [];

                if (tempCompDropOpts?.length) {
                    tempCompIds = tempVal.length > 0
                        ? tempCompDropOpts
                            .filter(option => tempVal.includes(option.value))
                            .map(option => option.tagLabel)
                        : [];
                }
            }

            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldName]: _.uniq(e?.map((item: DropdownProps) => item.value)),
                    ...(fieldName === "companyCodeList" && { companyIdList: tempCompIds })
                }
            }
        })
    };


    const onSearchFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key) || []);
        }
        standardProposalDispatch(prevState => {
            let tempCompIds: string[] = [];
            if (fieldKey === "companyCodeList") {
                const tempCompDropOpts = prevState.dynamicOptions.companyCodeDropdownOptions || [];

                if (tempCompDropOpts?.length && val) {
                    tempCompIds = val.length > 0
                        ? tempCompDropOpts
                            .filter(option => val.includes(option.value))
                            .map(option => option.tagLabel)
                        : [];
                }
            }

            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val,
                    ...(fieldKey === "companyCodeList" && { companyIdList: tempCompIds })
                },
            }
        })
    }


    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        standardProposalDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const onGroupButtonClick = async (buttonId: string) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: [],
                deleteTierList: [],
                deleteIsList: [],
                deleteItemList: [],
                // standardProposalList: [],
                isShowTariffItemPanel: false,
                isShowTariffItemTierPanel: false,
                isCopyEditTier: false,
                isUpdateOrAdd: false,
                isAddTariffItem: false,
                isShowCopyPanel: false,
                isEditPercentage: false,
                isEditProposalNo: false,
                isEditNewProposalNo: false,
                selectCopyToStdProposalRows: [],
                standardProposalItemList: null,
                currentSelectedRow: { ...EMPTY_STANDARD_PROPOSAL_ENTITY },
                isAddIs: false,
                isEditIs: false,
                isAddTier: false,
                isEditTier: false,
                isEditStdProposal: false,
                copyToCompanyList: [],
                copyToPercentageList: [],
                copyToProposalList: [],
                copyToNewProposalList: [],
                copyToEditNewProposal: { ...EMPTY_STD_PROPOSAL_COPY_TO_NEW_PROPOSAL_ENTITY },
                copyToEditPercentage: { ...EMPTY_STD_PROPOSAL_COPY_TO_ENTITY },
                copyToProposalNo: { ...EMPTY_STD_PROPOSAL_COPY_TO_PROPOSAL_ENTITY },
            }
        })
        let isPendingApproval = false;
        let isRejected = false;
        // let isAll = false;
        let status = "";
        switch (buttonId) {
            case 'isPendingApproval':
                isPendingApproval = true;
                isRejected = false;
                // isAll = false;
                status = "FINALIZED";
                break;
            case 'isRejected':
                // isAll = false;
                isPendingApproval = false;
                isRejected = true;
                status = "REJECTED";
                break;
            // case 'isAll':  
            //     isAll = true;
            //     isPendingApproval = false;
            //     isRejected = false;
            //     status = "ALL";
            //     break;  
            default:
        }
        let searchCriteria = {
            ...EMPTY_STANDARD_PROPOSAL_SEARCH_CRITERIA,
            statusList: status ? [status] : []
        };

        await Promise.allSettled([
            searchAllStandardProposal(),
            standardProposalRepo.searchStandardProposal(searchCriteria).then((data) => {
                if (data && data.length > 0) {
                    standardProposalDispatch(prevState => {
                        let newList: StandardProposalEntity[] = [];
                        if (status !== "") {
                            if (status === "FINALIZED") {
                                newList = data?.filter(entity => entity.status === "FINALIZED" && !entity.confirmedDate);
                            } else {
                                newList = data?.filter(entity => entity.status === status);
                            }
                            newList = _.orderBy(newList, ["companyCode", "proposalNo"], ['asc', 'asc']);
                        }
                        return {
                            ...prevState,
                            selectedRows: [],
                            // isAll: isAll,
                            isPendingApproval: isPendingApproval,
                            isRejected: isRejected,
                            standardProposalList: newList,
                            searchStatus: buttonId,
                            isAllowAutoSearch: false
                        }
                    })
                }
            })
        ])
    }

    const onDeleteClick = async (entities: StandardProposalEntity[]) => {
        return await standardProposalRepo.deleteSTDProposal(entities.map(entity => entity.key));
    }

    const onSubmit = async (selectedRows: StandardProposalEntity[]) => {
        return await standardProposalRepo.submitStandardProposal(selectedRows);
    }

    const onUnconfirm = async (selectedRows: StandardProposalEntity[]) => {
        return await standardProposalRepo.unconfirmStandardProposal(selectedRows);
    }

    const onTextAreaChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        return standardProposalDispatch(prevState => {
            return {
                ...prevState,
                [fieldKey]: val
            }
        });
    }

    const onRejectReasonTextAreaChange = (fieldValue: IFieldValue) => {
        let val: any = fieldValue;
        return standardProposalDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: {
                    ...prevState.currentSelectedRow,
                    rejectReason: val
                }
            }
        });
    }

    const closeRejectReasonModal = () => {
        standardProposalDispatch(prevState => ({
            ...prevState,
            isShowRejectPad: false,
            isRejecting: true,
        }))
    };
    const cancelRejectReasonModal = () => {
        standardProposalDispatch(prevState => ({
            ...prevState,
            isShowRejectPad: false,
            isRejecting: false,
            currentSelectedRow: {
                ...prevState.currentSelectedRow,
                rejectReason: prevState.rejectReason,
            }
        }))
    };

    const onRejectClick = () => {
        standardProposalDispatch(prevState => ({
            ...prevState,
            isShowRejectPad: true,
        }))
    };

    const onReject = async (searchCriteria: StandardProposalSearchCriteria, searchStatus: string, selectedRow: StandardProposalEntity) => {
        closeRejectReasonModal();
        await standardProposalRepo.onRejectStandardProposal(selectedRow).then(async (data) => {
            if (searchStatus !== "") {
                onGroupButtonClick(searchStatus);
            } else {
                await searchStandardProposal(searchCriteria);
            }
            standardProposalDispatch(prevState => ({
                ...prevState,
                isRejecting: false,
                rejectReason: ""
            }))
        });
    };

    const onApprove = async (selectedRows: StandardProposalEntity[]) => {
        return await standardProposalRepo.approveStandardProposal(selectedRows);
    }

    const onAddClick = () => {
        standardProposalDispatch(prevState => ({
            ...prevState,
            isShowDetail: true,
        }))
    };

    const searchStandardProposalItem = async (entity: StandardProposalEntity) => {
        if (!entity.key) {
            return;
        }

        // initComboBoxTariffCode(entity,"all");
        await standardProposalItemRepo.searchStandardProposalItem(entity).then((data) => {
            const newData = _.orderBy(data, ["priority"]);
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    standardProposalItemList: newData,
                    tariffItemSelectedRows: [],
                }
            })
        }).catch((error) => {
            return [];
        })
    }

    const onHeaderSingleDropdownChange = (e: any, fieldName: string) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: {
                    ...prevState.currentSelectedRow,
                    [fieldName]: e.value,
                }
            }
        });
    };

    const onHeaderMultipleDropdownChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        standardProposalDispatch(prevState => ({
            ...prevState,
            currentSelectedRow: {
                ...prevState.currentSelectedRow,
                [fieldKey]: val,
                // tariffNature: val.join()
            }
        }));
    };

    const onCopyToCompanyCodeProposal = async (copyToCompanyList: string[]) => {
        standardProposalDispatch(prevState => {
            let items: StdProposalCopyToProposalEntity[] = prevState.copyToProposalList?.slice();
            const filterCompanyCode = items.filter(item => copyToCompanyList.includes(item.companyCode));
            const updatedCompanyCode = copyToCompanyList.reduce((acc, companyCode) => {
                const existingCode = acc?.find(item => item.companyCode === companyCode);
                if (!existingCode) {
                    acc.push({ companyCode, proposalNo: '', copyToNewTariff: [] });
                }
                return acc;
            }, filterCompanyCode);
            return {
                ...prevState,
                copyToProposalList: updatedCompanyCode,
            }
        })
    }

    const onCopyToCompanyFieldChange = async (isCopyToNewProposal: boolean, fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        if (!isCopyToNewProposal) {
            standardProposalDispatch(prevState => {
                let updatedCompanyCode: StdProposalCopyToProposalEntity[] = [];
                if (val) {
                    let copyToCompanyList = val as string[];
                    let items: StdProposalCopyToProposalEntity[] = prevState.copyToProposalList?.slice();
                    const filterCompanyCode = items.filter(item => copyToCompanyList.includes(item.companyCode));
                    let tariffItems = prevState.tariffItemSelectedRows?.slice();
                    updatedCompanyCode = copyToCompanyList.reduce((acc, companyCode) => {
                        const existingCode = acc?.find(item => item.companyCode === companyCode);
                        if (!existingCode) {
                            let TariffItemTierList = new Map<string, StdProposalTariffItemTierEntity[]>();
                            tariffItems.forEach(tariff => {
                                const tierList = tariff.tierList?.slice();
                                const copyToPercentages = prevState.copyToPercentageList.filter(item => item.tariffType === tariff.tariffType);
                                let copyToNewTariffItemTierList: StdProposalTariffItemTierEntity[] = [];
                                if (!_.isEmpty(copyToPercentages)) {
                                    const calPercentage = copyToPercentages[0];
                                    copyToNewTariffItemTierList = tierList ? tierList.map(tier => {
                                        const newRate = applyRounding(
                                            (tier?.rate ?? 0) * (calPercentage.chargePercentage * 0.01),
                                            calPercentage.roundMethod,
                                            calPercentage.decimalPlace
                                        );
                                        const newMinimum = applyRounding(
                                            (tier?.minimum ?? 0) * (calPercentage.chargePercentage * 0.01),
                                            calPercentage.roundMethod,
                                            calPercentage.decimalPlace
                                        );
                                        const newSurcharge = tier?.surcharge ? applyRounding(
                                            tier?.surcharge * (calPercentage.chargePercentage * 0.01),
                                            calPercentage.roundMethod,
                                            calPercentage.decimalPlace
                                        ) : null;
                                        const newAdditionalRate = tier?.additionalRate ? applyRounding(
                                            tier?.additionalRate * (calPercentage.chargePercentage * 0.01),
                                            calPercentage.roundMethod,
                                            calPercentage.decimalPlace
                                        ) : null;
                                        return {
                                            ...tier,
                                            rate: newRate,
                                            minimum: newMinimum,
                                            surcharge: newSurcharge,
                                            additionalRate: newAdditionalRate,
                                        }
                                    }) : [];
                                }
                                TariffItemTierList.set(tariff.tariffType + tariff.tariffCode, copyToNewTariffItemTierList);
                            });
                            // let previewEntities: StandardProposalItemPreviewEntity[] = [];
                            // const newCopyToCompanyList = newCompanyList.map(entity => entity.companyCode);
                            // previewEntities = copyToCompanyList.flatMap(companyCode =>
                            //     tariffItems.map(entity => ({
                            //         companyCode,
                            //         itemId: entity.key,
                            //         tariffType: entity.tariffType,
                            //         tariffCode: entity.tariffCode,
                            //         forworderCode: entity.forworderCode,
                            //         copyToNewTariffItemTierList: copyToNewTariffItemTierList
                            //     } as StandardProposalItemPreviewEntity))
                            // );
                            let previewEntities = new Map<string, StandardProposalItemPreviewEntity[]>();
                            copyToCompanyList.forEach(companyCode => {
                                const companyItems = tariffItems.map(entity => ({
                                    companyCode,
                                    itemId: entity.key,
                                    tariffType: entity.tariffType,
                                    tariffCode: entity.tariffCode,
                                    forworderCode: entity.forworderCode,
                                    copyToNewTariffItemTierList: TariffItemTierList.get(entity.tariffType + entity.tariffCode)
                                } as StandardProposalItemPreviewEntity));

                                previewEntities.set(companyCode, companyItems);
                            });
                            acc.push({ companyCode, proposalNo: '', copyToNewTariff: previewEntities.get(companyCode) ?? [] });
                        }
                        return acc;
                    }, filterCompanyCode);

                }
                return {
                    ...prevState,
                    [fieldKey]: val ?? [],
                    isEditProposalNo: false,
                    copyToProposalList: updatedCompanyCode,
                }
            })
        } else {
            standardProposalDispatch(prevState => {
                let updatedCompanyCode: StdProposalCopyToNewProposalEntity[] = [];
                if (val) {
                    let copyToCompanyList = val as string[];
                    let items: StdProposalCopyToNewProposalEntity[] = prevState.copyToNewProposalList?.slice();
                    let tariffItems = prevState.tariffItemSelectedRows?.slice();
                    const filterCompanyCode = items.filter(item => copyToCompanyList.includes(item.companyCode));
                    updatedCompanyCode = copyToCompanyList.reduce((acc, companyCode) => {
                        const existingCode = acc?.find(item => item.companyCode === companyCode);
                        if (!existingCode) {
                            let TariffItemTierList = new Map<string, StdProposalTariffItemTierEntity[]>();
                            tariffItems.forEach(tariff => {
                                const tierList = tariff.tierList?.slice();
                                const copyToPercentages = prevState.copyToPercentageList.filter(item => item.tariffType === tariff.tariffType);
                                let copyToNewTariffItemTierList: StdProposalTariffItemTierEntity[] = [];
                                if (!_.isEmpty(copyToPercentages)) {
                                    const calPercentage = copyToPercentages[0];
                                    copyToNewTariffItemTierList = tierList ? tierList.map(tier => {
                                        const newRate = applyRounding(
                                            (tier?.rate ?? 0) * (calPercentage.chargePercentage * 0.01),
                                            calPercentage.roundMethod,
                                            calPercentage.decimalPlace
                                        );
                                        const newMinimum = applyRounding(
                                            (tier?.minimum ?? 0) * (calPercentage.chargePercentage * 0.01),
                                            calPercentage.roundMethod,
                                            calPercentage.decimalPlace
                                        );
                                        const newSurcharge = tier?.surcharge ? applyRounding(
                                            tier?.surcharge * (calPercentage.chargePercentage * 0.01),
                                            calPercentage.roundMethod,
                                            calPercentage.decimalPlace
                                        ) : null;
                                        const newAdditionalRate = tier?.additionalRate ? applyRounding(
                                            tier?.additionalRate * (calPercentage.chargePercentage * 0.01),
                                            calPercentage.roundMethod,
                                            calPercentage.decimalPlace
                                        ) : null;
                                        return {
                                            ...tier,
                                            rate: newRate,
                                            minimum: newMinimum,
                                            surcharge: newSurcharge,
                                            additionalRate: newAdditionalRate,
                                        }
                                    }) : [];
                                }
                                TariffItemTierList.set(tariff.tariffType + tariff.tariffCode, copyToNewTariffItemTierList);
                            });
                            // let previewEntities: StandardProposalItemPreviewEntity[] = [];
                            // previewEntities = copyToCompanyList.flatMap(companyCode =>
                            //     tariffItems.map(entity => ({
                            //         companyCode,
                            //         itemId: entity.key,
                            //         tariffType: entity.tariffType,
                            //         tariffCode: entity.tariffCode,
                            //         forworderCode: entity.forworderCode,
                            //         copyToNewTariffItemTierList: copyToNewTariffItemTierList
                            //     } as StandardProposalItemPreviewEntity))
                            // );
                            let previewEntities = new Map<string, StandardProposalItemPreviewEntity[]>();
                            copyToCompanyList.forEach(companyCode => {
                                const companyItems = tariffItems.map(entity => ({
                                    companyCode,
                                    itemId: entity.key,
                                    tariffType: entity.tariffType,
                                    tariffCode: entity.tariffCode,
                                    forworderCode: entity.forworderCode,
                                    copyToNewTariffItemTierList: TariffItemTierList.get(entity.tariffType + entity.tariffCode)
                                } as StandardProposalItemPreviewEntity));

                                previewEntities.set(companyCode, companyItems);
                            });

                            let newEty = { ...EMPTY_STD_PROPOSAL_COPY_TO_NEW_PROPOSAL_ENTITY };
                            newEty = {
                                ...newEty,
                                companyCode: companyCode,
                                copyToNewTariff: previewEntities.get(companyCode) ?? [],
                            }
                            acc.push(newEty);
                        }
                        return acc;
                    }, filterCompanyCode);

                }
                return {
                    ...prevState,
                    [fieldKey]: val ?? [],
                    isEditProposalNo: false,
                    copyToNewProposalList: updatedCompanyCode,
                }
            })
        }


    }

    const onCopyPercentageFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        if (!val) {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    copyToEditPercentage: {
                        ...prevState.copyToEditPercentage,
                        [fieldKey]: val,
                    },
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...prevState.stdProposalState.allFormState,
                            [fieldKey]: ''
                        },
                    }
                }
            })
        } else {
            standardProposalDispatch(prevState => {
                if (fieldKey === 'chargePercentage') {
                    var posIntReg = /^\d*(\.\d{0,2})?$/;
                    if (!posIntReg.test(val)) {
                        val = prevState.copyToEditPercentage[fieldKey];
                    }
                }
                return {
                    ...prevState,
                    copyToEditPercentage: {
                        ...prevState.copyToEditPercentage,
                        [fieldKey]: val,
                    },
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...prevState.stdProposalState.allFormState,
                            [fieldKey]: ''
                        },
                    }
                }
            })

        }
    }
    const onCopyNewProposalNoFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                copyToEditNewProposal: {
                    ...prevState.copyToEditNewProposal,
                    [fieldKey]: val,
                },
                stdProposalState: {
                    ...prevState.stdProposalState,
                    allFormState: {
                        ...prevState.stdProposalState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onCopyProposalNoFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                copyToEditProposalNo: {
                    ...prevState.copyToEditProposalNo,
                    [fieldKey]: val,
                },
                stdProposalState: {
                    ...prevState.stdProposalState,
                    allFormState: {
                        ...prevState.stdProposalState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }
    const onCopyFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        if (!val) {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    [fieldKey]: val,
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...prevState.stdProposalState.allFormState,
                            [fieldKey]: ''
                        },
                    }
                }
            })
        } else {
            standardProposalDispatch(prevState => {
                if ((fieldKey === 'chargePercentage' || fieldKey === 'decimalPlace')) {
                    var posIntReg = /^\d*(\.\d{0,2})?$/;
                    if (!posIntReg.test(val)) {
                        val = prevState[fieldKey];
                    }
                }
                return {
                    ...prevState,
                    [fieldKey]: val,
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...prevState.stdProposalState.allFormState,
                            [fieldKey]: ''
                        },
                    }
                }
            })
        }

    }

    const onHeaderFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: {
                    ...prevState.currentSelectedRow,
                    [fieldKey]: val,
                },
                stdProposalState: {
                    ...prevState.stdProposalState,
                    allFormState: {
                        ...prevState.stdProposalState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onTariffNatureFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        standardProposalDispatch(prevState => {
            let oldTariffNature: any = prevState.currentSelectedRow.tariffNatureList;
            let message = "";
            if (oldTariffNature && (oldTariffNature?.length ?? 0) > 0) {
                const missingValue = oldTariffNature?.find((x: any) => !(val || []).includes(x));
                if (oldTariffNature && oldTariffNature.length > (val?.length ?? 0)) {
                    let tariffNature: { [key: string]: string[] } = prevState.tariffNatureMap;
                    if (tariffNature.hasOwnProperty(missingValue)) {
                        let value = tariffNature[missingValue];
                        let currentStandardItem: StandardProposalItemEntity[] = prevState.standardProposalItemList || [];

                        if (currentStandardItem && !_.isEmpty(currentStandardItem)) {
                            for (const item of currentStandardItem) {
                                let concatenatedString = `${item.tariffType}_${item.tariffCode}`;
                                if (value.includes(concatenatedString)) {
                                    message = `Cannot delete the tariff nature - ${missingValue}. Tariff codes which under this tariff nature exists in the proposal.`;
                                    val = oldTariffNature;
                                    break
                                }
                            }
                        }
                    }
                }
            }

            return {
                ...prevState,
                currentSelectedRow: {
                    ...prevState.currentSelectedRow,
                    tariffNature: _.join(val, ","),
                    [fieldKey]: val,
                },
                allFormState: { "updateNewTariffNatureFail": message }
            }
        })
    }

    const onTierFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        if (!val) {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    currentEditTariffItemTier: {
                        ...prevState.currentEditTariffItemTier,
                        [fieldKey]: val
                    },
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...prevState.stdProposalState.allFormState,
                            [fieldKey]: ''
                        },
                    }
                }
            })
        } else {
            standardProposalDispatch(prevState => {
                if (prevState.currentEditTariffItemTier && (fieldKey === 'cycle' || fieldKey === 'forevery')) {
                    var posIntReg = /^\d*$/;
                    if (!posIntReg.test(val)) {
                        val = prevState.currentEditTariffItemTier[fieldKey];
                    }
                }
                if (prevState.currentEditTariffItemTier && (fieldKey === 'rate' || fieldKey === 'minimum' || fieldKey === 'surcharge' || fieldKey === 'additionalRate')) {
                    var numberReg = /^-?\d*(\.\d{0,2})?$/;
                    if (!numberReg.test(val)) {
                        val = prevState.currentEditTariffItemTier[fieldKey];
                    }
                }
                return {
                    ...prevState,
                    currentEditTariffItemTier: {
                        ...prevState.currentEditTariffItemTier,
                        [fieldKey]: val
                    },
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...prevState.stdProposalState.allFormState,
                            [fieldKey]: ''
                        },
                    }
                }
            })
        }

    }

    const onIsFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        standardProposalDispatch(prevState => {
            if (prevState.currentEditTariffItemIs && (fieldKey === 'percentage')) {
                var numberReg = /^\d*(\.\d{0,2})?$/;
                if (!numberReg.test(val)) {
                    val = prevState.currentEditTariffItemIs[fieldKey];
                }
            }
            return {
                ...prevState,
                currentEditTariffItemIs: {
                    ...prevState.currentEditTariffItemIs,
                    [fieldKey]: val
                },
            }
        })
    }

    const onTariffItemFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        // let tarCode: any;
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        standardProposalDispatch(prevState => {
            // if(fieldKey ==='tariffType'){
            //     tarCode = prevState.dynamicOptions.tariffCodeDropdownOptions[val]?prevState.dynamicOptions.tariffCodeDropdownOptions[val][0].value:"";
            // }
            // if(fieldKey ==='tariffCode'){
            //     tarCode = val;
            // }
            return {
                ...prevState,
                currentTariffItem: {
                    ...prevState.currentTariffItem,
                    [fieldKey]: val,
                    // tariffCode:tarCode && tarCode!==null ? tarCode : prevState.currentTariffItem.tariffCode,
                },
                stdProposalState: {
                    ...prevState.stdProposalState,
                    allFormState: {
                        ...prevState.stdProposalState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onHeaderDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        standardProposalDispatch(prevState => ({
            ...prevState,
            currentSelectedRow: {
                ...prevState.currentSelectedRow,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const onHeaderTextAreaChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        return standardProposalDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: {
                    ...prevState.currentSelectedRow,
                    [fieldKey]: val,
                }
            }
        });
    }

    // const onTariffItemRowDoubleClick = (entity: StandardProposalItemEntity) => {
    //     return standardProposalDispatch(prevState => {
    //         return {
    //             ...prevState,
    //             isShowTariffItemTierPanel: true,
    //             isShowCopyPanel: false,
    //             copyToCompanyList: [],
    //             copyToNewProposalList: [],
    //             copyToPercentageList: [],
    //             copyToProposalList: [],
    //             isEditPercentage: false,
    //             isEditProposalNo: false,
    //             isEditNewProposalNo: false,
    //             selectCopyToStdProposalRows: [],
    //             currentTariffItem: entity,
    //             isAddTariffItem: false,
    //             isEditStdProposal: false,
    //             isUpdateOrAdd: false,
    //         }
    //     });
    // }

    const cancelAddOrEdit = () => {
        return standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isAddIs: false,
                isEditIs: false,
                isAddTier: false,
                isEditTier: false,
                currentTariffItemTier: prevState.currentTariffItemTier,
                currentTariffItemIs: prevState.currentTariffItemIs,
                stdProposalState: {
                    ...prevState.stdProposalState,
                    allFormState: {
                    },
                }
            }
        });
    }

    const onAddIs = () => {
        let newEty = { ...EMPTY_STD_PROPOSAL_IS_ENTITY };
        newEty = {
            ...newEty,
            tempKey: _.uniqueId()
        }
        return standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isAddIs: true,
                isEditIs: false,
                isAddTier: false,
                isEditTier: false,
                isUpdateOrAdd: true,
                currentEditTariffItemIs: newEty
            }
        });
    }

    const onAddTier = () => {
        return standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isAddIs: false,
                isEditIs: false,
                isAddTier: true,
                isEditTier: false,
                isUpdateOrAdd: true,
                currentEditTariffItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY }
            }
        });
    }

    const onSaveStdProposalClick = async () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isEditStdProposal: false,
                currentSelectedRow: prevState.currentSelectedRow,
            };
        })
    }

    const onSaveStdProposal = async (entity: StandardProposalEntity) => {
        const valResult = await Validation(createStandardProposalValidationSchema).ValidateFormOnly(entity);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        return await standardProposalRepo.saveStandardProposal(entity);
    }

    const onSaveTariffItem = async (entity: StandardProposalEntity, currentItem: StandardProposalItemEntity, standardProposalItemList: StandardProposalItemEntity[], tariffCodeIds: string[]) => {
        //if (!deleteItemList || deleteItemList.length === 0) {
        const valResult = await Validation(createTariffItemValidationSchema).ValidateFormOnly(currentItem);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        //}
        let newList: StandardProposalItemEntity[] = [] /*standardProposalItemList?.slice()*/;
        /*if (!currentItem.key && currentItem.tariffType && currentItem.tariffCode) {*/
        if (!currentItem.priorityList?.length || currentItem.priorityList?.length < 1) {
            currentItem.priorityList = standardProposalItemList.filter(item => item.priorityList?.length && item.priorityList?.length > 0)[0]?.priorityList;
        }
        newList.push(
            {
                ...currentItem,
                priority: !currentItem.priority && (!currentItem.priorityList || !currentItem.priorityList.length) ? 1 : currentItem.priority
            }
        );
        /*} else {
            newList = standardProposalItemList.map(entity => entity.key === currentItem.key ? currentItem : entity);
        }*/
        let criteria: SaveTariffProposalItemCriteria = {
            tariffProposal: entity,
            // proposalItem:tariffItem,
            tariffCodeIds: tariffCodeIds,
            itemList: newList,
            deleteItemList: [],
        }
        /*standardProposalDispatch(prevState => {
            return {
                ...prevState,
                deleteItemList: []
            };
        })*/
        return await standardProposalItemRepo.saveTariffItem(criteria);
    }

    const onDeleteTariffItem = async (deleteItemList: StandardProposalItemEntity[]) => {
        let criteria: SaveTariffProposalItemCriteria = {
            tariffProposal: EMPTY_STANDARD_PROPOSAL_ENTITY,
            tariffCodeIds: [],
            itemList: [],
            deleteItemList: deleteItemList,
        }

        return await standardProposalItemRepo.deleteTariffItem(criteria).then((res) => {
            if (res && res.success) {
                standardProposalDispatch(prevState => {
                    let itemList = prevState.standardProposalItemList ?? []?.slice();
                    if (deleteItemList && deleteItemList.length > 0) {
                        itemList = itemList?.filter(item =>
                            !deleteItemList?.some(delItem => item.key === delItem.key)
                        );
                    }
                    return {
                        ...prevState,
                        standardProposalItemList: itemList,
                        currentTariffItem: { ...EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY },
                        tariffItemSelectedRows: [],
                        deleteItemList: []
                    }
                })
            }
            return res;
        }).catch((error) => {
            return null;
        })
    }

    const onSaveClicked = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                stdProposalState: {
                    ...prevState.stdProposalState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }


    const onTempSaveTariffItemTier = async (tier: StdProposalTariffItemTierEntity, isAddTier: boolean) => {
        const valResult = await Validation(createTempSaveTariffItemTierValidationSchema).ValidateFormOnly(tier);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
        } else {
            standardProposalDispatch(prevState => {
                let newTiers: StdProposalTariffItemTierEntity[] = [];
                // let tier = prevState.currentEditTariffItemTier;
                if (prevState.currentTariffItem.tierList) {
                    newTiers = prevState.currentTariffItem.tierList?.slice();
                    if (isAddTier) {
                        tier = {
                            ...tier,
                            tierNo: newTiers.length + 1,
                            newRecord: true,
                        }
                        newTiers.push(tier);
                    } else {
                        newTiers = newTiers.map(entity => entity.tierNo === tier.tierNo ? tier : entity);
                    }
                } else {
                    tier = {
                        ...tier,
                        tierNo: newTiers.length + 1,
                        newRecord: true,
                    }
                    newTiers.push(tier);
                }
                return {
                    ...prevState,
                    isEditTier: false,
                    isAddTier: false,
                    currentTariffItemTier: tier,
                    currentEditTariffItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY },
                    currentTariffItem: {
                        ...prevState.currentTariffItem,
                        tierList: newTiers,
                    }

                }
            })
        }
    }

    const onTempSaveTariffItemIs = async (isAddIs: boolean) => {
        standardProposalDispatch(prevState => {
            let newIsList: StdProposalIsEntity[] = [];
            let is = prevState.currentEditTariffItemIs;
            if (prevState.currentTariffItem.stdIsList) {
                newIsList = prevState.currentTariffItem.stdIsList?.slice();
                if (isAddIs) {
                    newIsList.push(is);
                } else {
                    newIsList = newIsList.map(entity => entity.id ? (entity.id === is.id ? is : entity) : (entity.tempKey === is.tempKey ? is : entity));
                }
            } else {
                newIsList.push(is);
            }
            return {
                ...prevState,
                isEditIs: false,
                isAddIs: false,
                currentTariffItemIs: is,
                currentEditTariffItemIs: { ...EMPTY_STD_PROPOSAL_IS_ENTITY },
                currentTariffItem: {
                    ...prevState.currentTariffItem,
                    stdIsList: newIsList,
                }

            }
        })
    }

    const initComboBoxTariffCode = async (entity: StandardProposalEntity, tariffType: string) => {
        standardProposalDispatch(prevState => ({
            ...prevState,
            currentTariffItem: {
                ...prevState.currentTariffItem,
                tariffCode: prevState.isAddTariffItem ? "" : prevState.currentTariffItem.tariffCode,
            },
            dynamicOptions: {
                ...prevState.dynamicOptions,
                tariffCodeDropdownOptions: [],
            }
        }))
        const criteria: TariffCodeComboxSearchCriteria = {
            stdProposal: entity,
            tariffType: tariffType ?? "all",
        }
        const tariffCodes = await standardTariffCodeRepo.getTariffCodeForStdProposal(criteria);
        let tariffCodeDropdownOptions = tariffCodes?.map((tariffCode) => ({
            dropdownLabel: tariffCode.split(':')[1],
            tagLabel: tariffCode.split(':')[1],
            value: tariffCode.split(':')[1],
        })) ?? []
        standardProposalDispatch(prevState => ({
            ...prevState,
            tariffCodeIds: tariffCodes,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                tariffCodeDropdownOptions: tariffCodeDropdownOptions,
            }
        }))
    }

    const onRenew = async (keys: number[]) => {
        return await standardProposalRepo.renewStandardProposal(keys);
    }

    const onTariffItemDeleteClick = async (deleteItems: StandardProposalItemEntity[]) => {
        standardProposalDispatch(prevState => {
            let deleteList = prevState.deleteItemList?.slice();
            //deleteList = [...deleteList, ...deleteItems];
            const tempDeleteList = deleteItems.filter(item =>
                !deleteList.some(existingItem => existingItem.id === item.id)
            );
            deleteList = [...deleteList, ...tempDeleteList];
            /*let itemList = prevState.standardProposalItemList ?? []?.slice();
            const newList = itemList?.filter(item =>
                !deleteItems?.some(delItem => item.tariffType === delItem.tariffType && item.tariffCode === delItem.tariffCode && item.forwarderCode === delItem.forwarderCode)
            );*/
            return {
                ...prevState,
                deleteItemList: deleteList,
                //isUpdateOrAdd: true,
                isShowTariffItemTierPanel: false,
                /*standardProposalItemList: newList,
                currentTariffItem: { ...EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY },
                tariffItemSelectedRows: [],*/
            }
        })
    }

    const onTariffItemTierDeleteClick = async (deleteTiers: StdProposalTariffItemTierEntity[]) => {
        standardProposalDispatch(prevState => {
            let tierList = prevState.currentTariffItem.tierList ?? [].slice();
            const newList = tierList.filter(tier =>
                !deleteTiers?.some(delTier => tier.tierNo === delTier.tierNo)
            ).map((tier, i) => ({ ...tier, tierNo: i + 1 }));
            return {
                ...prevState,
                isUpdateOrAdd: true,
                currentTariffItem: {
                    ...prevState.currentTariffItem,
                    tierList: newList,
                },

            }
        })
    }

    const onTariffItemIsDeleteClick = async (deleteIs: StdProposalIsEntity[]) => {
        standardProposalDispatch(prevState => {
            let isList = prevState.currentTariffItem.stdIsList ?? [].slice();
            const newList = isList.filter(is =>
                !deleteIs?.some(delIs => is.shiftCode === delIs.shiftCode)
            );
            return {
                ...prevState,
                isUpdateOrAdd: true,
                currentTariffItem: {
                    ...prevState.currentTariffItem,
                    stdIsList: newList,
                },
            }
        })
    }

    const onStdProposalSaveClick = async (stdProposal: StandardProposalEntity) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: stdProposal
            }
        })
    }

    const onTariffItemCopyClick = async (isNew: boolean) => {
        standardProposalDispatch(prevState => {
            let copyToEntities: StdProposalCopyToEntity[] = [];
            let items: StandardProposalItemEntity[] = prevState.tariffItemSelectedRows?.slice();
            let uniqueTariffTypes = new Set<string>();
            if (items.length > 0) {
                let uniqueItems = items.filter(item => {
                    if (!uniqueTariffTypes.has(item.tariffType)) {
                        uniqueTariffTypes.add(item.tariffType);
                        return true;
                    }
                    return false;
                });
                copyToEntities = uniqueItems.map((tariff) => ({
                    tariffType: tariff.tariffType,
                    chargePercentage: 100,
                    roundMethod: "ROUND",
                    decimalPlace: "2",
                }));
            }

            return {
                ...prevState,
                copyToPercentageList: copyToEntities,
                isCopyToNewProposal: isNew,
                isShowTariffItemTierPanel: true,
                isShowCopyPanel: true,
                isUpdateOrAdd: false,
                isAddIs: false,
                isEditIs: false,
                isAddTier: false,
                isEditTier: false,
            }
        })
    }

    const onTariffItemCopyCloseClick = async () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                copyToCompanyList: [],
                copyToNewProposalList: [],
                copyToPercentageList: [],
                copyToProposalList: [],
                isEditPercentage: false,
                isEditProposalNo: false,
                isEditNewProposalNo: false,
                isShowCopyPanel: false,
                isShowTariffItemTierPanel: false,
                isCopyToNewProposal: false,
                stdProposalState: {
                    ...prevState.stdProposalState,
                    allFormState: {
                    },
                }
            }
        })
    }

    const onTariffItemCopyEditCloseClick = async () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isEditPercentage: false,
                isEditProposalNo: false,
                isEditNewProposalNo: false,
                copyToEditPercentage: { ...EMPTY_STD_PROPOSAL_COPY_TO_ENTITY },
                copyToProposalNo: { ...EMPTY_STD_PROPOSAL_COPY_TO_PROPOSAL_ENTITY },
            }
        })
    }

    const onCopyEditPercentageSaveClick = async (copyToEditPercentage: StdProposalCopyToEntity) => {
        const valResult = await Validation(copyToEditPercentageValidationSchema).ValidateFormOnly(copyToEditPercentage);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
        } else {
            standardProposalDispatch(prevState => {
                const data = prevState.copyToPercentageList?.slice();
                let edit = copyToEditPercentage;
                const updatedArr = data.map(item =>
                    item.tariffType === edit.tariffType ? edit : item
                );
                const tariffItemList = prevState.tariffItemSelectedRows?.slice();
                const calPercentageList = updatedArr.filter(entity => entity.tariffType === edit.tariffType);
                const calPercentage = calPercentageList[0];
                if (prevState.isCopyToNewProposal) {
                    const newProposalList = prevState.copyToNewProposalList.slice();
                    const updateProposalList = newProposalList.map(item => {
                        return {
                            ...item,
                            copyToNewTariff: item.copyToNewTariff.map(tariff => {
                                if (tariff.tariffType === edit.tariffType) {
                                    const tarffItem = tariffItemList.find(entity => entity.tariffType === tariff.tariffType && entity.tariffCode === tariff.tariffCode);
                                    return {
                                        ...tariff,
                                        copyToNewTariffItemTierList: tarffItem && tarffItem.tierList ? tarffItem.tierList.map(tier => {
                                            const newRate = applyRounding(
                                                (tier?.rate ?? 0) * (calPercentage.chargePercentage * 0.01),
                                                calPercentage.roundMethod,
                                                calPercentage.decimalPlace
                                            );
                                            const newMinimum = applyRounding(
                                                (tier?.minimum ?? 0) * (calPercentage.chargePercentage * 0.01),
                                                calPercentage.roundMethod,
                                                calPercentage.decimalPlace
                                            );
                                            const newSurcharge = tier?.surcharge ? applyRounding(
                                                tier?.surcharge * (calPercentage.chargePercentage * 0.01),
                                                calPercentage.roundMethod,
                                                calPercentage.decimalPlace
                                            ) : null;
                                            const newAdditionalRate = tier?.additionalRate ? applyRounding(
                                                tier?.additionalRate * (calPercentage.chargePercentage * 0.01),
                                                calPercentage.roundMethod,
                                                calPercentage.decimalPlace
                                            ) : null;
                                            return {
                                                ...tier,
                                                rate: newRate,
                                                minimum: newMinimum,
                                                surcharge: newSurcharge,
                                                additionalRate: newAdditionalRate,
                                            }
                                        }) : []
                                    }
                                }
                                return tariff;
                            })
                        }
                    }
                    );
                    return {
                        ...prevState,
                        copyToPercentageList: updatedArr,
                        copyToNewProposalList: updateProposalList,
                        isEditPercentage: false,
                    }
                } else {
                    const newProposalList = prevState.copyToProposalList.slice();
                    const updateProposalList = newProposalList.map(item => {
                        return {
                            ...item,
                            copyToNewTariff: item.copyToNewTariff.map(tariff => {
                                if (tariff.tariffType === edit.tariffType) {
                                    const tarffItem = tariffItemList.find(entity => entity.tariffType === tariff.tariffType && entity.tariffCode === tariff.tariffCode);
                                    return {
                                        ...tariff,
                                        copyToNewTariffItemTierList: tarffItem && tarffItem.tierList ? tarffItem.tierList.map(tier => {
                                            const newRate = applyRounding(
                                                (tier?.rate ?? 0) * (calPercentage.chargePercentage * 0.01),
                                                calPercentage.roundMethod,
                                                calPercentage.decimalPlace
                                            );
                                            const newMinimum = applyRounding(
                                                (tier?.minimum ?? 0) * (calPercentage.chargePercentage * 0.01),
                                                calPercentage.roundMethod,
                                                calPercentage.decimalPlace
                                            );
                                            const newSurcharge = tier?.surcharge ? applyRounding(
                                                tier?.surcharge * (calPercentage.chargePercentage * 0.01),
                                                calPercentage.roundMethod,
                                                calPercentage.decimalPlace
                                            ) : null;
                                            const newAdditionalRate = tier?.additionalRate ? applyRounding(
                                                tier?.additionalRate * (calPercentage.chargePercentage * 0.01),
                                                calPercentage.roundMethod,
                                                calPercentage.decimalPlace
                                            ) : null;
                                            return {
                                                ...tier,
                                                rate: newRate,
                                                minimum: newMinimum,
                                                surcharge: newSurcharge,
                                                additionalRate: newAdditionalRate,
                                            }
                                        }) : []
                                    }
                                }
                                return tariff;
                            })
                        }
                    }
                    );
                    return {
                        ...prevState,
                        copyToPercentageList: updatedArr,
                        copyToProposalList: updateProposalList,
                        isEditPercentage: false,
                    }
                }
            })
        }
    }

    const onCopyEditProposalNoSaveClick = async (copyToEditProposalNo: StdProposalCopyToProposalEntity) => {
        const valResult = await Validation(copyEditProposalNoValidationSchema).ValidateFormOnly(copyToEditProposalNo);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
        } else {
            standardProposalDispatch(prevState => {
                const data = prevState.copyToProposalList?.slice();
                let edit = copyToEditProposalNo;
                const updatedArr = data.map(item =>
                    item.companyCode === edit.companyCode ? edit : item
                );
                return {
                    ...prevState,
                    copyToProposalList: updatedArr,
                    isEditProposalNo: false,
                }
            })
        }
    }

    const onCopyEditNewProposalNoSaveClick = async (copyToEditNewProposal: StdProposalCopyToNewProposalEntity) => {
        const valResult = await Validation(copyEditNewProposalNoValidationSchema).ValidateFormOnly(copyToEditNewProposal);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
        } else {
            standardProposalDispatch(prevState => {
                const data = prevState.copyToNewProposalList?.slice();
                let edit = copyToEditNewProposal;
                const updatedArr = data.map(item =>
                    item.companyCode === edit.companyCode ? edit : item
                );
                return {
                    ...prevState,
                    copyToNewProposalList: updatedArr,
                    isEditNewProposalNo: false,
                }
            })
        }
    }

    const onTariffItemNewCopy = async (fromTariffItemList: StandardProposalItemEntity[], copyToPercentageList: StdProposalCopyToEntity[], copyToNewProposalList: StdProposalCopyToNewProposalEntity[], currenctProposal: StandardProposalEntity) => {
        const criteria: CopyTariffProposalItemCriteria = {
            tariffCodeIds: [],
            fromTariffItemList: fromTariffItemList,
            copyToProposalList: [],
            copyToNewProposalList: copyToNewProposalList,
            copyToPercentageList: copyToPercentageList,
            currenctProposal: currenctProposal
        }
        return standardProposalItemRepo.copyStdProposalTariffItems(criteria);
    }

    const onTariffItemCombineCopy = async (fromTariffItemList: StandardProposalItemEntity[], copyToPercentageList: StdProposalCopyToEntity[], copyToProposalList: StdProposalCopyToProposalEntity[], currenctProposal: StandardProposalEntity) => {
        const criteria: CopyTariffProposalItemCriteria = {
            tariffCodeIds: [],
            copyToNewProposalList: [],
            fromTariffItemList: fromTariffItemList,
            copyToProposalList: copyToProposalList,
            copyToPercentageList: copyToPercentageList,
            currenctProposal: currenctProposal
        }
        return standardProposalItemRepo.copyStdProposalTariffItems(criteria);
    }

    const onPercentageDoubleClick = (entity: StdProposalCopyToEntity) => {
        return standardProposalDispatch(prevState => {
            return {
                ...prevState,
                copyToEditPercentage: entity,
                isEditPercentage: true,
                isEditProposalNo: false,
            }
        });
    }

    const onNewProposalNoDoubleClick = async (entity: StdProposalCopyToNewProposalEntity) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                copyToEditNewProposal: entity,
                isEditProposalNo: false,
                isEditPercentage: false,
                isEditNewProposalNo: true,
            }
        })
    }

    const onProposalNoDoubleClick = async (entity: StdProposalCopyToProposalEntity, companyCodeDropdownOptions: DropdownProps[]) => {

        let tempCompIds: string[] = [];
        const tempCompDropOpts = companyCodeDropdownOptions || [];

        if (tempCompDropOpts?.length && entity.companyCode) {
            tempCompIds = tempCompDropOpts
                .filter(option => entity.companyCode.includes(option.value))
                .map(option => option.tagLabel);
        }
        let searchCriteria = { ...EMPTY_STANDARD_PROPOSAL_SEARCH_CRITERIA };
        searchCriteria =
        {
            ...searchCriteria,
            companyCodeList: [entity.companyCode],
            companyIdList: tempCompIds,
            statusList: ['REJECTED', 'NEW'],
        }

        const data = await standardProposalRepo.searchStandardProposal(searchCriteria);
        if (data) {
            let companyCodeProposalNoDropdownOption = data?.map((ety) => ({
                dropdownLabel: ety.proposalNo ?? "",
                tagLabel: ety.proposalNo ?? "",
                value: ety.proposalNo ?? "",
            })) ?? []

            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    copyToEditProposalNo: entity,
                    isEditProposalNo: true,
                    isEditPercentage: false,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        companyCodeProposalNoDropdownOptions: companyCodeProposalNoDropdownOption,
                    }
                }
            })
        }
    }

    const onMasterOrAllianceClick = async (companyType: string, stdProposal: StandardProposalEntity) => {
        stdProposal = {
            ...stdProposal,
            previousCompanyId: "PreviousCompany" !== companyType ? stdProposal.key : stdProposal.previousCompanyId,
            companyType: companyType
        }
        onShowLoading();
        let msg = '';
        await standardProposalRepo.onMasterOrAlliance(stdProposal).then(async (data) => {
            if (data && data.success) {
                await searchStandardProposalItem(data.data).then((ret) => {
                    standardProposalDispatch(prevState => {
                        return {
                            ...prevState,
                            currentSelectedRow: data.data,
                            isMasterOrAlliance: "PreviousCompany" !== companyType
                        }
                    })
                    onHideLoading();
                });
            } else {
                onHideLoading();
                msg = data.data;
            }
        });
        return msg;
    }
    const onGenerateClick = async (standardProposalItemList: StandardProposalItemEntity[]) => {
        return await standardProposalItemRepo.onGenerate(standardProposalItemList);
    }

    const onMoveTariffItems = async (standardProposalItemList: StandardProposalItemEntity[]) => {
        return await standardProposalItemRepo.onMoveTariffItems(standardProposalItemList);
    }

    const onCloseClick = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isShowDetail: false,
                isBackFromDetail: true,
                isAllowAutoSearch: true,
                selectedRows: [],
                currentSelectedRow: { ...EMPTY_STANDARD_PROPOSAL_ENTITY },
            }
        });
    }

    const onShowPreviewPanel = (isCopyToNewProposal: boolean) => {
        standardProposalDispatch(prevState => {

            // const companyList = isCopyToNewProposal ? prevState.copyToNewProposalList?.slice() : prevState.copyToProposalList.slice();
            // const copyToCompanyList = companyList.map(entity => entity.companyCode);
            // let previewEntities: StandardProposalItemPreviewEntity[] = [];
            // let tariffItems = prevState.tariffItemSelectedRows?.slice();
            // previewEntities = copyToCompanyList.flatMap(companyCode =>
            //     tariffItems.map(entity => ({
            //         companyCode,
            //         itemId: entity.key,
            //         tariffType: entity.tariffType,
            //         tariffCode: entity.tariffCode,
            //         forworderCode: entity.forworderCode,
            //         copyToNewTariffItemTierList: []
            //     } as StandardProposalItemPreviewEntity))
            // );

            return {
                ...prevState,
                isShowPreviewPanel: true,
                isCopyEditTier: false,
                // copyToNewTariffList: previewEntities
            }
        });
    }
    const onClosePreviewPanel = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isShowPreviewPanel: false,
                selectCopyToNewTariff: { ...EMPTY_STANDARD_PROPOSAL_ITEM_PREVIEW_ENTITY },
            }
        });
    }

    const onShowTariffItemTierPanel = (entityList: StandardProposalItemPreviewEntity[], isCopyEditTier: boolean) => {
        if (isCopyEditTier) {
            if (!_.isEmpty(entityList)) {
                standardProposalDispatch(prevState => {
                    return {
                        ...prevState,
                        selectCopyToNewTariff: entityList[0]
                    }
                });
            } else {
                standardProposalDispatch(prevState => {
                    return {
                        ...prevState,
                        selectCopyToNewTariff: { ...EMPTY_STANDARD_PROPOSAL_ITEM_PREVIEW_ENTITY }
                    }
                });
            }
        } else {
            if (!_.isEmpty(entityList)) {
                const entity = entityList[0];
                standardProposalDispatch(prevState => {
                    let copyToNewTariffItemTierList: StdProposalTariffItemTierEntity[] = [];
                    let tariffItems = prevState.tariffItemSelectedRows?.slice();
                    let copyToPercentageList = prevState.copyToPercentageList?.slice();
                    tariffItems = tariffItems?.filter(tariffItem => tariffItem.key === entity.itemId);
                    if (!_.isEmpty(tariffItems)) {
                        const tierList = tariffItems[0].tierList?.slice();
                        const copyToPercentages = copyToPercentageList.filter(item => item.tariffType === entity.tariffType);
                        if (!_.isEmpty(copyToPercentages)) {
                            const calPercentage = copyToPercentages[0];
                            copyToNewTariffItemTierList = tierList ? tierList.map(tier => {
                                const newRate = applyRounding(
                                    (tier?.rate ?? 0) * (calPercentage.chargePercentage * 0.01),
                                    calPercentage.roundMethod,
                                    calPercentage.decimalPlace
                                );
                                const newMinimum = applyRounding(
                                    (tier?.minimum ?? 0) * (calPercentage.chargePercentage * 0.01),
                                    calPercentage.roundMethod,
                                    calPercentage.decimalPlace
                                );
                                const newSurcharge = tier?.surcharge ? applyRounding(
                                    tier?.surcharge * (calPercentage.chargePercentage * 0.01),
                                    calPercentage.roundMethod,
                                    calPercentage.decimalPlace
                                ) : null;
                                const newAdditionalRate = tier?.additionalRate ? applyRounding(
                                    tier?.additionalRate * (calPercentage.chargePercentage * 0.01),
                                    calPercentage.roundMethod,
                                    calPercentage.decimalPlace
                                ) : null;
                                return {
                                    ...tier,
                                    rate: newRate,
                                    minimum: newMinimum,
                                    surcharge: newSurcharge,
                                    additionalRate: newAdditionalRate,
                                }
                            }) : [];
                        }
                    }
                    return {
                        ...prevState,
                        selectCopyToNewTariff: {
                            ...entity,
                            copyToNewTariffItemTierList: copyToNewTariffItemTierList
                        },
                        // copyToNewTariffItemTierList: copyToNewTariffItemTierList
                    }
                });
            } else {
                standardProposalDispatch(prevState => {
                    return {
                        ...prevState,
                        selectCopyToNewTariff: { ...EMPTY_STANDARD_PROPOSAL_ITEM_PREVIEW_ENTITY }
                    }
                });
            }
        }
    }

    const applyRounding = (value: number, method: string, decimalPlace: string) => {
        const factor = Math.pow(10, Number(decimalPlace));
        switch (method) {
            case 'ROUND':
                return Math.round(value * factor) / factor;
            case 'ROUND DOWN':
                return Math.floor(value * factor) / factor;
            case 'ROUND UP':
                return Math.ceil(value * factor) / factor;
            default:
                throw new Error(`Unknown rounding method: ${method}`);
        }
    }

    const onTempSaveCopyItemTier = async (currentEditItemTier: StdProposalTariffItemTierEntity) => {
        const valResult = await Validation(createTempSaveTariffItemTierValidationSchema).ValidateFormOnly(currentEditItemTier);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    stdProposalState: {
                        ...prevState.stdProposalState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
        } else {

            standardProposalDispatch(prevState => {
                let newTiers: StdProposalTariffItemTierEntity[] = [];
                let tier = currentEditItemTier;
                const itemTierList = prevState.selectCopyToNewTariff.copyToNewTariffItemTierList.slice();
                if (itemTierList) {
                    newTiers = itemTierList?.slice();
                    newTiers = newTiers.map(entity => entity.tierNo === tier.tierNo ? tier : entity);
                } else {
                    tier = {
                        ...tier,
                        tierNo: newTiers.length + 1,
                        newRecord: true,
                    }
                    newTiers.push(tier);
                }

                let selectCopyToNewTariff = prevState.selectCopyToNewTariff;
                selectCopyToNewTariff = {
                    ...prevState.selectCopyToNewTariff,
                    copyToNewTariffItemTierList: newTiers
                }
                if (prevState.isCopyToNewProposal) {
                    let newProposalTariffs = prevState.copyToEditNewProposal.copyToNewTariff;
                    let newProposals = prevState.copyToNewProposalList;
                    newProposalTariffs = newProposalTariffs.map(entity => entity.tariffCode === selectCopyToNewTariff.tariffCode ? selectCopyToNewTariff : entity);
                    let newProposal = prevState.copyToEditNewProposal;
                    newProposal = {
                        ...newProposal,
                        copyToNewTariff: newProposalTariffs
                    }
                    newProposals = newProposals.map(entity => entity.companyCode === newProposal.companyCode ? newProposal : entity);
                    return {
                        ...prevState,
                        copyToNewProposalList: newProposals,
                        copyToEditNewProposal: newProposal,
                        selectCopyToNewTariff: selectCopyToNewTariff,
                        isShowCopyEditTierPanel: false,
                        isCopyEditTier: true,
                    }
                } else {
                    let newProposalTariffs = prevState.copyToEditProposalNo.copyToNewTariff;
                    let newProposals = prevState.copyToProposalList;
                    newProposalTariffs = newProposalTariffs.map(entity => entity.tariffCode === selectCopyToNewTariff.tariffCode ? selectCopyToNewTariff : entity);
                    let newProposal = prevState.copyToEditProposalNo;
                    newProposal = {
                        ...newProposal,
                        copyToNewTariff: newProposalTariffs
                    }
                    newProposals = newProposals.map(entity => entity.companyCode === newProposal.companyCode ? newProposal : entity);
                    return {
                        ...prevState,
                        copyToProposalList: newProposals,
                        copyToProposalNo: newProposal,
                        selectCopyToNewTariff: selectCopyToNewTariff,
                        isShowCopyEditTierPanel: false,
                        isCopyEditTier: true,
                    }

                }
            })
        }
    }

    const cancelEdit = async () => {

        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isShowCopyEditTierPanel: false,
                currentEditTariffItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY },
            }
        })
    }

    const onDoubleClickTariffItemTierRatePanel = (entity: StdProposalTariffItemTierEntity) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isShowCopyEditTierPanel: true,
                currentEditTariffItemTier: entity,
            }
        });
    }

    const onShowTariffItemTierRatePanel = (entityList: StdProposalTariffItemTierEntity[]) => {
        if (!_.isEmpty(entityList)) {
            const entity = entityList[0];
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    currentItemTier: entity,
                }
            });
        } else {
            standardProposalDispatch(prevState => {
                return {
                    ...prevState,
                    currentItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY },
                }
            });
        }
    }

    const resetInitialProposalItem = () => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                initialProposalItem: false,
            }
        });
    }

    const setIsSearchLoading = (isSearchLoading: boolean) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isSearchLoading: isSearchLoading,
            }
        })
    }

    const setIsLoadingTarItem = (isLoadingTarItem: boolean) => {
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isLoadingTarItem: isLoadingTarItem,
            }
        })
    }

    const onClearMessage = () => {
        standardProposalDispatch(prevState => ({
            ...prevState,
            allFormState: { "updateNewTariffNatureFail": '' }
        }))
    }

    return {
        onShowTariffItemTierRatePanel: onShowTariffItemTierRatePanel,
        onDoubleClickTariffItemTierRatePanel: onDoubleClickTariffItemTierRatePanel,
        cancelEdit: cancelEdit,
        onTempSaveCopyItemTier: onTempSaveCopyItemTier,
        onShowTariffItemTierPanel: onShowTariffItemTierPanel,
        onClosePreviewPanel: onClosePreviewPanel,
        onShowPreviewPanel: onShowPreviewPanel,
        onMoveTariffItems: onMoveTariffItems,
        onGenerateClick: onGenerateClick,
        onMasterOrAllianceClick: onMasterOrAllianceClick,
        onTariffItemNewCopy: onTariffItemNewCopy,
        onCopyEditNewProposalNoSaveClick: onCopyEditNewProposalNoSaveClick,
        onCopyNewProposalNoFieldChange: onCopyNewProposalNoFieldChange,
        updateSelectedNewProposalNoRow: updateSelectedNewProposalNoRow,
        onNewProposalNoDoubleClick: onNewProposalNoDoubleClick,
        onTariffItemCombineCopy: onTariffItemCombineCopy,
        onCopyPercentageFieldChange: onCopyPercentageFieldChange,
        onCopyProposalNoFieldChange: onCopyProposalNoFieldChange,
        onTariffItemCopyEditCloseClick: onTariffItemCopyEditCloseClick,
        onCopyEditProposalNoSaveClick: onCopyEditProposalNoSaveClick,
        onCopyEditPercentageSaveClick: onCopyEditPercentageSaveClick,
        onPercentageDoubleClick: onPercentageDoubleClick,
        onProposalNoDoubleClick: onProposalNoDoubleClick,
        updateSelectedProposalNoRow: updateSelectedProposalNoRow,
        updateSelectedPercentageRow: updateSelectedPercentageRow,
        onCopyToCompanyCodeProposal: onCopyToCompanyCodeProposal,
        onCopyToCompanyFieldChange: onCopyToCompanyFieldChange,
        onCopyFieldChange: onCopyFieldChange,
        onTariffItemCopyCloseClick: onTariffItemCopyCloseClick,
        updateCopyToSelectedRows: updateCopyToSelectedRows,
        onTariffItemCopyClick: onTariffItemCopyClick,
        onStdProposalSaveClick: onStdProposalSaveClick,
        onTariffItemIsDeleteClick: onTariffItemIsDeleteClick,
        onTariffItemDeleteClick: onTariffItemDeleteClick,
        onTariffItemTierDeleteClick: onTariffItemTierDeleteClick,
        onHeaderMultipleDropdownChange: onHeaderMultipleDropdownChange,
        onHeaderSingleDropdownChange: onHeaderSingleDropdownChange,
        onHeaderTextAreaChange: onHeaderTextAreaChange,
        onHeaderDateRangeChange: onHeaderDateRangeChange,
        onHeaderFieldChange: onHeaderFieldChange,
        onTierFieldChange: onTierFieldChange,
        onIsFieldChange: onIsFieldChange,
        loadDropdownOption: loadDropdownOption,
        onShowLoading: onShowLoading,
        onHideLoading: onHideLoading,
        onRowDoubleClick: onRowDoubleClick,
        updateSelectedRows: updateSelectedRows,
        onSearchCriteriaResetClick: onSearchCriteriaResetClick,
        onSearchClick: onSearchClick,
        searchStandardProposal: searchStandardProposal,
        searchAllStandardProposal: searchAllStandardProposal,
        onSearchInputTextChange: onSearchInputTextChange,
        onMultipleDropdownChange: onMultipleDropdownChange,
        onDateRangeChange: onDateRangeChange,
        onGroupButtonClick: onGroupButtonClick,
        onDeleteClick: onDeleteClick,
        onSubmit: onSubmit,
        onUnconfirm: onUnconfirm,
        onTextAreaChange: onTextAreaChange,
        closeRejectReasonModal: closeRejectReasonModal,
        cancelRejectReasonModal: cancelRejectReasonModal,
        onRejectClick: onRejectClick,
        onReject: onReject,
        onApprove: onApprove,
        onAddClick: onAddClick,
        searchStandardProposalItem: searchStandardProposalItem,
        onTariffItemCloseClick: onTariffItemCloseClick,
        onTariffItemEidtClick: onTariffItemEidtClick,
        onTariffItemRowDoubleClick: onTariffItemRowDoubleClick,
        onTariffItemTierCloseClick: onTariffItemTierCloseClick,
        onTariffItemTierEidtClick: onTariffItemTierEidtClick,
        onTariffItemISEidtClick: onTariffItemISEidtClick,
        onTariffItemFieldChange: onTariffItemFieldChange,
        updateSelectedTariffItemTierRows: updateSelectedTariffItemTierRows,
        updateSelectedTariffItemIsRows: updateSelectedTariffItemIsRows,
        updateSelectedTariffItemRows: updateSelectedTariffItemRows,
        cancelAddOrEdit: cancelAddOrEdit,
        onAddIs: onAddIs,
        onAddTier: onAddTier,
        onRowClick: onRowClick,
        onSaveStdProposalClick: onSaveStdProposalClick,
        onSaveStdProposal: onSaveStdProposal,
        onTariffItemAddClick: onTariffItemAddClick,
        onRejectReasonTextAreaChange: onRejectReasonTextAreaChange,
        initComboBoxTariffCode: initComboBoxTariffCode,
        onSaveTariffItem: onSaveTariffItem,
        onTempSaveTariffItemTier: onTempSaveTariffItemTier,
        onTempSaveTariffItemIs: onTempSaveTariffItemIs,
        onRenew: onRenew,
        onTariffNatureFieldChange: onTariffNatureFieldChange,
        onCloseClick: onCloseClick,
        onSaveClicked: onSaveClicked,
        updateCurrentSelectedRow: updateCurrentSelectedRow,
        resetInitialProposalItem: resetInitialProposalItem,
        setIsSearchLoading: setIsSearchLoading,
        setIsLoadingTarItem: setIsLoadingTarItem,
        onClearMessage: onClearMessage,
        onSearchFieldChange: onSearchFieldChange,
        onDeleteTariffItem: onDeleteTariffItem
    }
}